import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { addWidget, removeWidget, reorderWidget } from "../db/action";
import { selectWidgets } from "../db/select";
import { db } from "../db/state";
import { useSelector } from "../lib/db/react";
import { widgetConfigs } from "../plugins";
import SettingWidget from "./SettingWidget";

const messages = defineMessages({
  addWidget: {
    id: "settings.widgets.addWidget",
    defaultMessage: "Add a new widget",
  },
});

const SettingWidgets: React.FC = () => {
  const intl = useIntl();
  const widgets = useSelector(db, selectWidgets);

  return (
    <div>
      <label>
        <select
          value=""
          onChange={(event) => addWidget(event.target.value)}
          className="primary"
        >
          <option disabled value="">
            {intl.formatMessage(messages.addWidget)}
          </option>
          {widgetConfigs.map((plugin) => (
            <option key={plugin.key} value={plugin.key}>
              {plugin.name}
            </option>
          ))}
        </select>
      </label>

      {widgets.map((widget, index) => (
        <SettingWidget
          key={widget.id}
          plugin={widget}
          onMoveUp={
            index > 0 ? () => reorderWidget(index, index - 1) : undefined
          }
          onMoveDown={
            index < widgets.length - 1
              ? () => reorderWidget(index, index + 1)
              : undefined
          }
          onRemove={() => removeWidget(widget.id)}
        />
      ))}
    </div>
  );
};

export default SettingWidgets;
